import React, { useEffect, useState } from 'react';
import useWatch from '../../Hooks/UseWatch';
import InventoryDetails from './InventoryDetails';
import './Inventory.css'
import { ClockLoader } from 'react-spinners';
import { Link } from 'react-router-dom';

const Inventory = () => {
    const [watchs] = useWatch();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
  
    }, []);
    return (
        <div className='Inventory-bg'>
            <div className='container py-5'>
                <div className='row'>
                    <div className='col-6'>
                        <h1 className='text-info text-start display-3 py-5 fw-bold'>Inventory</h1>
                    </div>
                    <div className='col-6 mt-4 mt-5 text-end'>
                        <Link to='/manage' className='btn btn-outline-info mt-5'>Manage</Link>
                    </div>
                </div>
                {
                loading ?
                    <div className="w-100 h-100 d-flex justify-content-center align-items-center" >
                        <ClockLoader color={"#22d3ee"} loading={loading} size={200} />
                    </div> :
                    <div className="row g-5">
                        {
                            watchs.map(watch => <InventoryDetails
                                key={watch._id}
                                watch={watch}
                            >
                            </InventoryDetails>)
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default Inventory;